<ng-container *transloco="let t; read: 'ime.common.properties'">
  <ng-select #select class="select-sm form-control dropdown-auto-width"
             bindValue="Id" groupBy="GroupClv"
             [items]="(allFilteredItems$ || allItems$) | async"
             [name]="name"
             [class.readOnly]="readonly"
             [readonly]="readonly"
             [bindLabel]="bindLabel"
             [searchFn]="searchFn"
             [(ngModel)]="entityId"
             (open)="readonly ? select.close() : select.open()"
             (change)="entityIdChange.emit($event?.Id)"
             [appendTo]="appendTo"
             [clearable]="clearable">
    <ng-template ng-label-tmp let-item="item">
      <div class="d-flex justify-content-between text-wrap text-break">
        <ng-container *ngLet="(allItems$ | async | find : 'Id' : item?.Id) as propertyQuery">
          {{ propertyQuery?.Code ?? item?.Id | localizedValue: 'property': 'name': (propertyQuery?.DisplayName ?? item?.Id) | async }}
        </ng-container>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-searchTerm="searchTerm">
      <ng-container *ngIf="(allItems$ | async | find : 'Id' : item?.Id) as propertyQuery">
        <div class="d-flex">
          <span [ngOptionHighlight]="searchTerm">
            {{ propertyQuery.Code | localizedValue: 'property': 'name': (propertyQuery[bindLabel] ?? item?.Id) | async }}
          </span>
        </div>
      </ng-container>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item">
      <a class="badge bg-default text-white text-decoration-none" (click)="toggleGroupFilter(item.GroupClv)">
        {{ (classificatorValuesQuery.selectEntity(item.GroupClv) | async)?.Code || '' }}
      </a>
    </ng-template>
    <ng-template ng-header-tmp>
      <ng-container *ngIf="favourites.length">
        <div class="me-auto" *ngFor="let f of favourites">
          <button class="btn btn-sm btn-outline-primary m-1" (click)="setEntityId(f); select.close()" *ngIf="(allItems$ | async | find: ['Id']: f) as p">
            {{ p.DisplayName }}
          </button>
        </div>
      </ng-container>
    </ng-template>
    <ng-template ng-footer-tmp>
      <div class="me-auto my-auto">
        <a *ngFor="let group of clonedPropertyGroups" class="badge bg-default ms-1 text-white text-decoration-none" (click)="toggleGroupFilter(group)">
          {{ (classificatorValuesQuery.selectEntity(group) | async)?.Code || '' }} &times;
        </a>
      </div>
      <button *ngIf="allowAdd && entityId" class="btn btn-sm btn-outline-primary m-1" (click)="select.close(); editProperty()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      </button>
      <button *ngIf="allowEdit" class="btn btn-sm btn-outline-primary m-1" (click)="select.close(); addNewProperty()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      </button>
    </ng-template>
    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <button type="button" *ngIf="allowAdd" class="btn btn-sm btn-outline-primary m-1" (click)="select.close(); addNewProperty(searchTerm)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
          {{ t('Add') }} "{{ searchTerm }}"
        </button>
      </div>
    </ng-template>
  </ng-select>
</ng-container>
